export default "__VITE_ASSET__c10IL8AK__"